<template>
  <div>
    <div class="panel has-bg">
      <h3>{{ $t('edgeDistanceEC.headlineDimensions') }}</h3>
      <div class="row">
        <div class="col-lg-6">
          <!-- Spannweite -->
          <b-form-group label-for="componentSpan">
            <template slot="label">
              {{ $t('edgeDistanceEC.componentSpan') }}
              <span class="text-muted">I</span>
              <b-button
                id="popover-component-span"
                variant="default"
                tabindex="-1"
              >
                <font-awesome-icon icon="question-circle" />
              </b-button>
              <b-popover
                target="popover-component-span"
                triggers="hover"
                placement="top"
              >
                <p>{{ $t('edgeDistanceEC.componentSpanTooltip') }}</p>
                <!--                  <p v-html="$t('general.tooltipAdditionalInfo')"></p>-->
              </b-popover>
            </template>
            <b-input-group append="mm">
              <FormInputDecimal
                id="componentSpan"
                v-model="componentSpan"
              />
            </b-input-group>
          </b-form-group>
        </div>
        <div class="col-lg-6">
          <!-- Bautteillänge -->
          <b-form-group label-for="componentLength">
            <template slot="label">
              {{ $t('edgeDistanceEC.componentLength') }}
              <span class="text-muted">I<sub>n</sub></span>
            </template>
            <b-input-group append="mm">
              <FormInputDecimal
                id="componentLength"
                v-model="componentLength"
              />
            </b-input-group>
          </b-form-group>
        </div>
      </div>
<!--      <div class="row">-->
<!--        <div class="col-md-6">-->
<!--          &lt;!&ndash; Betongüte &ndash;&gt;-->
<!--          <b-form-group label-for="concreteQuality">-->
<!--            <template slot="label">-->
<!--              {{ $t('edgeDistanceEC.concreteQuality') }}-->
<!--            </template>-->
<!--            <b-input-group>-->
<!--              <b-form-select-->
<!--                id="concreteQuality"-->
<!--                v-model="concreteQuality"-->
<!--                :options="concreteQualitySelectOptions"-->
<!--              >-->
<!--              </b-form-select>-->
<!--            </b-input-group>-->
<!--          </b-form-group>-->
<!--        </div>-->
<!--      </div>-->
    </div>
    <div class="panel has-bg">
      <h3>
        a<sub>1</sub>
        <b-button
          id="popover-depth-supporting-a1"
          variant="link"
          tabindex="-1"
        >
          <font-awesome-icon icon="question-circle" />
        </b-button>
        <b-popover
          target="popover-depth-supporting-a1"
          triggers="hover"
          placement="top"
        >
          <p>{{ $t('edgeDistanceEC.supportBaseTooltip') }}</p>
          <!--            <p v-html="$t('general.tooltipAdditionalInfo')"></p>-->
        </b-popover>
      </h3>
      <div class="row">
        <div class="col-lg-6">
          <!-- Auflagerbauweise -->
          <b-form-group label-for="supportBaseType">
            <template slot="label">
              {{ $t('edgeDistanceEC.supportBaseType') }}
            </template>
            <b-input-group>
              <b-form-select
                id="supportBaseType"
                v-model="supportBaseType"
                :options="supportBaseTypeSelectOptions"
              >
              </b-form-select>
            </b-input-group>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6">
          <h3>
            a<sub>2</sub>
            <b-button
              id="popover-depth-supporting-a2"
              variant="link"
              tabindex="-1"
            >
              <font-awesome-icon icon="question-circle" />
            </b-button>
            <b-popover
              target="popover-depth-supporting-a2"
              triggers="hover"
              placement="top"
            >
              <p>{{ $t('edgeDistanceEC.distanceSupportingTooltip') }}</p>
              <!--                <p v-html="$t('general.tooltipAdditionalInfo')"></p>-->
            </b-popover>
          </h3>
          <!-- Bauweise stützende Bauteil -->
          <b-form-group label-for="supportingBearingType">
            <template slot="label">
              {{ $t('edgeDistanceEC.supportingBearingType') }}
            </template>
            <b-input-group>
              <b-form-select
                id="supportingBearingType"
                v-model="supportingBearingType"
                :options="supportingBearingTypeSelectOptions"
              >
              </b-form-select>
            </b-input-group>
          </b-form-group>
        </div>
        <div class="col-lg-6">
          <h3>
            &#916;
            <span class="text-muted">a<sub>2</sub></span>
            <b-button
              id="popover-depth-max-supporting-a2"
              variant="link"
              tabindex="-1"
            >
              <font-awesome-icon icon="question-circle" />
            </b-button>
            <b-popover
              target="popover-depth-max-supporting-a2"
              triggers="hover"
              placement="top"
            >
              <p>{{ $t('edgeDistanceEC.depthMaxSupportingTooltip') }}</p>
              <!--                <p v-html="$t('general.tooltipAdditionalInfo')"></p>-->
            </b-popover>
          </h3>
          <!-- Art stützende Bauteil -->
          <b-form-group label-for="maxSupportingBearingType">
            <template slot="label">
              {{ $t('edgeDistanceEC.maxSupportingBearingType') }}
            </template>
            <b-input-group>
              <b-form-select
                id="supportingConstructionType"
                v-model="maxSupportingBearingType"
                :options="maxSupportingBearingTypeSelectOptions"
              >
              </b-form-select>
            </b-input-group>
          </b-form-group>
        </div>
      </div>
      <h3>
        a<sub>3</sub>
        <b-button
          id="popover-depth-supporting-a3"
          variant="link"
          tabindex="-1"
        >
          <font-awesome-icon icon="question-circle" />
        </b-button>
        <b-popover
          target="popover-depth-supporting-a3"
          triggers="hover"
          placement="top"
        >
          <p>{{ $t('edgeDistanceEC.distanceSupportedTooltip') }}</p>
          <!--            <p v-html="$t('general.tooltipAdditionalInfo')"></p>-->
        </b-popover>
      </h3>
      <div class="row">
        <div class="col-lg-6">
          <!-- Bewehrung stützende Bauteil -->
          <b-form-group label-for="supportedReinforcement">
            <template slot="label">
              {{ $t('edgeDistanceEC.supportedReinforcement') }}
            </template>
            <b-input-group>
              <b-form-select
                id="supportedReinforcement"
                v-model="supportedReinforcement"
                :options="supportedReinforcementSelectOptions"
              >
              </b-form-select>
            </b-input-group>
          </b-form-group>
        </div>
        <div class="col-lg-6">
          <!-- Art des Lagers -->
          <b-form-group label-for="supportedBearingType">
            <template slot="label">
              {{ $t('edgeDistanceEC.supportedBearingType') }}
            </template>
            <b-input-group>
              <b-form-select
                id="supportedBearingType"
                v-model="supportedBearingType"
                :options="supportedBearingTypeSelectOptions"
              >
              </b-form-select>
            </b-input-group>
          </b-form-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line no-console
import { mapState, mapGetters } from 'vuex';
import CalcToolsTransverseTractionHelper from '../../helpers/CalcToolsTransverseTractionHelper';
import FormInputDecimal from '../app/form/FormInputDecimal.vue';
import DataOptionsHelper from '../../helpers/DataOptionsHelper';

export default {
  name: 'FixedBearingsFormEffects',
  components: {
    FormInputDecimal,
  },
  // props: {
  //   propBearingWidth: {
  //     type: Number,
  //     default: 100,
  //   },
  //   propBearingLength: {
  //     type: Number,
  //     default: 150,
  //   },
  //   propBearingThickness: {
  //     type: Number,
  //     default: 20,
  //   },
  //   propPower: {
  //     type: Number,
  //     default: 100,
  //   },
  // },
  data() {
    return {
      // concreteQuality: 'C12/15',
      // componentSpan: 6000,
      // componentLength: 5000,
      concreteQualityOptions: this.$dataOptionsHelper.getConcreteQualityOptions(),
      // concreteQualitySelectOptions:
      //   Object.values(this.$dataOptionsHelper.getConcreteQualityOptions()),
      // supportedBearingTypeOptions:
      //   this.$dataOptionsHelper.getSupportedBearingTypeOptions(this.$i18n),
      // supportedBearingTypeSelectOptions:
      //   Object.values(this.$dataOptionsHelper.getSupportedBearingTypeOptions(this.$i18n)),
      // maxSupportingBearingTypeOptions:
      //   this.$dataOptionsHelper.getMaxSupportingTypeOptions(this.$i18n),
      // maxSupportingBearingTypeSelectOptions:
      //   Object.values(this.$dataOptionsHelper.getMaxSupportingTypeOptions(this.$i18n)),
      // supportBaseType: '-',
      // supportingBearingType: '-',
      // supportedReinforcement: '-',
      // supportedBearingType: '-',
      // maxSupportingBearingType: '-',
      // steelStretchMax: 435,
      // bearingWidth: this.propBearingWidth,
      // bearingLength: this.propBearingLength,
      // bearingThickness: this.propBearingThickness,
      // power: this.propPower,
    };
  },
  computed: {
    ...mapState({
      concreteQuality: state => state.fixedBearingConcreteType,
      // componentLength: state => state.fixedBearingComponentLength,
      // componentSpan: state => state.fixedBearingComponentSpan,
      bearingWidth: state => state.fixedBearingWidth,
      bearingLength: state => state.fixedBearingLength,
      bearingThickness: state => state.fixedBearingThickness,
      power: state => state.fixedBearingPressureForce,
      countHoles: state => state.fixedBearingHolesCount,
      holesDiameter: state => state.fixedBearingHolesDiameter,
    }),
    ...mapGetters([
      'warningMessages',
      'typ100ConventionalPermissibleCompressiveStress',
      'typ100PermissibleTwisting',
      'typ100PermissibleAlphaResulting',
      'typ100ConventionalIsPossibile',
      'typ100ConventionalPermissiblePressureForce',
      'typ150ConventionalPermissibleCompressiveStress',
      'typ150PermissibleTwisting',
      'typ150PermissibleAlphaResulting',
      'typ150ConventionalPermissiblePressureForce',
      'typ150ConventionalIsPossibile',
      'typ200ConventionalPermissibleCompressiveStress',
      'typ200PermissibleTwisting',
      'typ200PermissibleAlphaResulting',
      'typ200ConventionalPermissiblePressureForce',
      'typ200ConventionalIsPossibile',
      'pyramideIsPossibile',
    ]),
    compressiveStress() {
      return CalcToolsTransverseTractionHelper.getCompressiveStress(
        this.bearingWidth,
        this.bearingLength,
        this.$outputHelper.convertToInteger(this.power),
        this.countHoles,
        this.holesDiameter,
      );
    },
    // effectUprightFactor() {
    //   return CalcToolsTransverseTractionHelper.getEffectUprightFactor(
    //     this.bearingWidth,
    //     this.bearingLength,
    //     this.$outputHelper.convertToInteger(this.power) * 1000,
    //   );
    // },
    transverseTractionEffectA() {
      return CalcToolsTransverseTractionHelper.getTransverseTractionA(
        this.bearingWidth,
        this.bearingLength,
        this.bearingThickness,
        this.power,
        this.compressiveStress,
      );
    },
    transverseTractionEffectB() {
      return CalcToolsTransverseTractionHelper.getTransverseTractionB(
        this.bearingWidth,
        this.bearingLength,
        this.bearingThickness,
        this.power,
        this.compressiveStress,
      );
    },
    concretePressure() {
      const option = this.concreteQualityOptions[this.concreteQuality];
      return option ? option.factorCube : 0;
    },
    bearingSqueeze() {
      return this.$outputHelper.convertToFloat(this.compressiveStress, 1)
        / this.$outputHelper.convertToInteger(this.concretePressure);
    },
    // supportedReinforcementSelectOptions() {
    //   return Object.values(
    //     this.$dataOptionsHelper.getReinforcementOptions(this.$i18n, this.supportedBearingType),
    //   );
    // },
    // supportingBearingTypeSelectOptions() {
    //   return Object.values(this.$dataOptionsHelper.getSupportingBearingTypeOptions(
    //     this.$i18n,
    //     this.bearingSqueeze,
    //   ));
    // },
    supportBaseTypeSelectOptions() {
      const rawOptions = DataOptionsHelper.getSupportBaseTypeOptions(this.bearingSqueeze);

      return Object.values(rawOptions).map(option => ({
        value: option.value,
        text: this.$i18n.t(option.textKey),
      }));
    },
    supportingBearingTypeSelectOptions() {
      const rawOptions = DataOptionsHelper.getSupportingBearingTypeOptions(this.bearingSqueeze);

      return Object.values(rawOptions).map(option => ({
        value: option.value,
        text: this.$i18n.t(option.textKey),
      }));
    },
    maxSupportingBearingTypeSelectOptions() {
      const rawOptions = DataOptionsHelper.getMaxSupportingTypeOptions(this.bearingSqueeze);

      return Object.values(rawOptions).map(option => ({
        value: option.value,
        text: this.$i18n.t(option.textKey),
      }));
    },
    supportedReinforcementSelectOptions() {
      const rawOptions = DataOptionsHelper.getReinforcementOptions(this.bearingSqueeze);

      return Object.values(rawOptions).map(option => ({
        value: option.value,
        text: this.$i18n.t(option.textKey),
      }));
    },
    supportedBearingTypeSelectOptions() {
      const rawOptions = DataOptionsHelper.getSupportedBearingTypeOptions();

      return Object.values(rawOptions).map(option => ({
        value: option.value,
        text: this.$i18n.t(option.textKey),
      }));
    },
    componentLength: {
      get() {
        return this.$store.state.fixedBearingComponentLength;
      },
      set(value) {
        this.$store.commit('fixedBearingComponentLength', value);
      },
    },
    componentSpan: {
      get() {
        return this.$store.state.fixedBearingComponentSpan;
      },
      set(value) {
        this.$store.commit('fixedBearingComponentSpan', value);
      },
    },
    supportBaseType: {
      get() {
        return this.$store.state.fixedBearingSupportBaseType;
      },
      set(value) {
        this.$store.commit('fixedBearingSupportBaseType', value);
      },
    },
    supportingBearingType: {
      get() {
        return this.$store.state.fixedBearingSupportingBearingType;
      },
      set(value) {
        this.$store.commit('fixedBearingSupportingBearingType', value);
      },
    },
    maxSupportingBearingType: {
      get() {
        return this.$store.state.fixedBearingMaxSupportingBearingType;
      },
      set(value) {
        this.$store.commit('fixedBearingMaxSupportingBearingType', value);
      },
    },
    supportedReinforcement: {
      get() {
        return this.$store.state.fixedBearingSupportedReinforcement;
      },
      set(value) {
        this.$store.commit('fixedBearingSupportedReinforcement', value);
      },
    },
    supportedBearingType: {
      get() {
        return this.$store.state.fixedBearingSupportedBearingType;
      },
      set(value) {
        this.$store.commit('fixedBearingSupportedBearingType', value);
      },
    },

    // supportBaseTypeSelectOptions() {
    //   return Object.values(
    //     this.$dataOptionsHelper.getSupportBaseTypeOptions(this.$i18n, this.bearingSqueeze),
    //   );
    // },
    recommended() {
      let bearingType = '';
      /* if (this.pyramideIsPossibile) {
        bearingType = 'pyramide';
      } else */
      if (
      /* !this.pyramideIsPossibile
          && */
        this.typ100ConventionalIsPossibile
      ) {
        bearingType = 'typ100';
      } else if (
      /* !this.pyramideIsPossibile
          &&  */
        !this.typ100ConventionalIsPossibile
          && this.typ150ConventionalIsPossibile
      ) {
        bearingType = 'typ150';
      } else if (
      /* !this.pyramideIsPossibile
          && */
        !this.typ100ConventionalIsPossibile
          && !this.typ150ConventionalIsPossibile
          && this.typ200ConventionalIsPossibile
      ) {
        bearingType = 'typ200';
      }
      return bearingType;
    },
  },
  watch: {
    supportBaseType: 'emitCompletion',
    supportingBearingType: 'emitCompletion',
    maxSupportingBearingType: 'emitCompletion',
    supportedReinforcement: 'emitCompletion',
    supportedBearingType: 'emitCompletion',
  },
  methods: {
    openModal(type) {
      this.$store.commit('fixedBearingSelectedBearingType', type);
      this.$bvModal.show('conventionalModalOutput');
    },
    emitCompletion() {
      const complete = Boolean(
        this.supportBaseType !== '-'
        && this.supportingBearingType !== '-'
        && this.maxSupportingBearingType !== '-'
        && this.supportedReinforcement !== '-'
        && this.supportedBearingType !== '-',
      );

      this.$emit('completion-changed', complete);
    },
  },
};
</script>

<style scoped lang="scss">
  .table-col-type {
    width: 25%;
  }
  .table-col-possibility {
    width: 25%;
  }
  .table-col-recommended {
    width: 25%;
  }
  .table-col-print {
    width: 25%;
  }
</style>
